import { SftpRetrievalFailureCode } from '@today/types'

// What a failed connection test means to a Super-Admin (TO-393 SCN-014).

const TEST_FAILURE_MESSAGES: Partial<Record<SftpRetrievalFailureCode, string>> = {
	[SftpRetrievalFailureCode.SFTP_AUTH_FAILED]:
		'Authentication failed — check the public key is installed for this user',
	[SftpRetrievalFailureCode.SFTP_CONNECTION_FAILED]:
		'Could not connect — check the host, the port and that our IP addresses are allowed',
	[SftpRetrievalFailureCode.SFTP_HOST_KEY_MISMATCH]: 'The server presented a different host key',
	[SftpRetrievalFailureCode.SFTP_PERMISSION_DENIED]: 'The server refused access for this user',
}

/** The message of a failed test's code; a generic one for any other code. */
export const testFailureMessage = (code: SftpRetrievalFailureCode | null): string =>
	(code && TEST_FAILURE_MESSAGES[code]) ?? 'The connection test failed'
